import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "../../../Components/Tabs";
import ListLayout from "../../../Core/Layout/ListLayout";
import Table from "../../../Core/Table/Table";
import Pagination from "../../../Core/Pagination/Pagination";
import ActionButtonDropdown from "../../../Components/ActionButtonDropdown";
import ConfigureColumnsNew from "../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from "../../../Core/Export/ExportCSV";
import ListFilters from "../../../Core/ListFilters/ListFilters";
import Button from "../../../Core/Button/Button";
import useScreenHeight from "../../../utils/useScreenHeight";
import GetIcon from "../../../utils/Icon";


const qualityActionSeedData = Array.from({ length: 500 }, (_, index) => {
  const id = String(index + 1).padStart(4, '0');
  const statuses = ["Open", "Completed"];
  const salesPersons = ["Mark Jensen", "Mila Patel", "Samuel Reed", "Nina Bose", "John Smith", "Sarah Wilson"];

  const randomDate = new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000);
  
  return {
    id: `QA-${id}`,
    serialNo: `QA-ACT-${id}`,
    review: `QA-REV-${id}`,
    salesPerson: salesPersons[Math.floor(Math.random() * salesPersons.length)],
    date: randomDate.toISOString(),
    dateTime: `${randomDate.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })} ${randomDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true })}`,
    status: statuses[Math.floor(Math.random() * statuses.length)],
    lastUpdated: randomDate.toISOString(),
  };
});
console.log("data ", qualityActionSeedData)
const statusColors = {
   Open: "#EF4444",
   
  Completed : "#5EB24A",

};

const priorityColors = {
  high: "#EF4444",
  medium: "#F59E0B",
  low: "#10B981",
};

const MainList = () => {
  const navigate = useNavigate();
  const { pageSize } = useScreenHeight();
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [showColumns, setShowColumns] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [qualityActions] = useState(qualityActionSeedData);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [columnsConfig, setColumnsConfig] = useState([
  
    {
      header: "Sl No.",
      accessor: "siNo",
      name: "Sl No.",
      width: "6%",
      sortable: false,
      visible: true,
      cellRenderer: (row) => String(row.siNo).padStart(2, "0"),
    },
    {
      header: "Id",
      accessor: "serialNo",
      name: "Id",
      width: "12%",
      sortable: true,
      visible: true,
    },
    {
      header: "Review",
      accessor: "review",
      name: "Review",
      width: "14%",
      sortable: true,
      visible: true,
    },
    {
      header: "Date & Time",
      accessor: "dateTime",
      name: "Date & Time",
      width: "18%",
      sortable: true,
      visible: true,
    },
    {
      header: "Status",
      accessor: "status",
      name: "Status",
      width: "12%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => {
        const getStatusConfig = (status) => {
          switch (status) {
            case "Completed":
              return { color: "#FFFFFF", bgColor: "#5EB24A" };
            case "Open":
              return { color: "#FFFFFF", bgColor: "#EF4444" };
            default:
              return { color: "#FFFFFF", bgColor: "#6B7280" };
          }
        };
        
        const config = getStatusConfig(row.status);
        
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                // backgroundColor: config.bgColor,
              }}
            />
            <span
              style={{
                color: config.bgColor,
                fontSize: "12px",
                fontWeight: 500,
                textTransform: "capitalize",
              }}
            >
              {row.status?.toLowerCase()}
            </span>
          </div>
        );
      },
    },
    {
      header: "Action",
      accessor: "action",
      name: "Action",
      width: "10%",
      
      sortable: false,
      visible: true,
      
      
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.id}
          onView={() => handleView(row.id)}
          onEdit={() => handleEdit(row.id)}
          onDelete={() => handleDelete(row.id)}
        />
      ),
    },
   
  ]);

  const filtersConfig = [
    { name: "serialNo", label: "Id", type: "text", width: "16%" },
    { name: "review", label: "Review", type: "text", width: "16%" },
    { name: "salesPerson", label: "Sales Person", type: "text", width: "16%" },
    {
      name: "status",
      label: "Status",
      type: "select",
      width: "16%",
      options: [
        { value: "Open", label: "Open" },
        { value: "In Progress", label: "In Progress" },
        { value: "Closed", label: "Closed" },
      ],
    },
  ];

  const filteredRows = useMemo(() => {
    const hasFilters = Object.values(filters).some(Boolean);
    if (!hasFilters) {
      return qualityActions;
    }

    return qualityActions.filter((row) =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const fieldValue = row[key];
        if (typeof fieldValue === "string") {
          return fieldValue.toLowerCase().includes(String(value).toLowerCase());
        }
        return fieldValue === value;
      })
    );
  }, [filters, qualityActions]);

  const handleInlineFilterChange = (name, value) => {
    setCurrentPage(1);
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const tableData = useMemo(() => {
    const page_length = 10;
    const start = (currentPage - 1) * page_length;
    const end = start + page_length;

    return filteredRows.slice(start, end).map((row, index) => ({
      ...row,
      siNo: index + 1 + start,
    }));
  }, [filteredRows, currentPage]);

  const toggleRowSelection = (rowIndex) => {
    setSelectedRows((prev) => {
      if (prev.includes(rowIndex)) {
        return prev.filter((idx) => idx !== rowIndex);
      } else {
        return [...prev, rowIndex];
      }
    });
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const currentPageIndices = tableData.map(
        (_, index) => (currentPage - 1) * 10 + index
      );
      setSelectedRows(currentPageIndices);
    }
    setSelectAll(!selectAll);
  };

  useMemo(() => {
    const currentPageIndices = tableData.map(
      (_, index) => (currentPage - 1) * 10 + index
    );
    const allSelected = currentPageIndices.every((index) =>
      selectedRows.includes(index)
    );
    setSelectAll(allSelected && currentPageIndices.length > 0);
  }, [selectedRows, tableData, currentPage]);

  const handleView = (id) => {
    navigate("/master/quality-review/view-quality-action", {
      state: { actionId: id },
    });
  };

  const handleEdit = (id) => {
    navigate("/master/quality-review/edit-quality-action", {
      state: { actionId: id },
    });
  };

  const handleDelete = (id) => {
    console.log("Delete Quality Action", id);
  };

  const handleSaveColumns = (selectedKeys) => {
    setColumnsConfig((prev) =>
      prev.map((column) => ({
        ...column,
        visible: selectedKeys.includes(column.accessor),
      }))
    );
  };

  const visibleColumns = useMemo(
    () =>
      columnsConfig
        .filter((col) => col.visible)
        .map((col) => {
          if (col.isCheckboxColumn) {
            return {
              ...col,
              header: () => (
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={selectAll}
                  onChange={toggleSelectAll}
                  style={{ marginLeft: "25px" }}
                />
              ),
              cellRenderer: (_, rowIndex) => (
                <div className="text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedRows.includes((currentPage - 1) * 10 + rowIndex)}
                    onChange={() => toggleRowSelection((currentPage - 1) * 10 + rowIndex)}
                  />
                </div>
              ),
            };
          }
          return col;
        }),
    [columnsConfig, selectAll, selectedRows, currentPage]
  );
  const defaultSelectedColumns = useMemo(
    () =>
      columnsConfig
        .filter((col) => col.visible)
        .map((col) => ({
          fieldname: col.accessor,
          label: col.name,
        })),
    [columnsConfig]
  );

  const exportFields = useMemo(
    () =>
      columnsConfig
        .filter(
          (column) =>
            column.accessor &&
            !["action", "siNo", "select", "settings"].includes(column.accessor)
        )
        .map((column) => column.accessor),
    [columnsConfig]
  );

  const activeFilterCount = useMemo(
    () =>
      Object.values(filters).filter(
        (value) => value !== undefined && value !== ""
      ).length,
    [filters]
  );


    const actionButtons = [
      {
        className: "btn-filter border-0 d-flex",
        style: { gap: "2px", height: "28px", background: "#A2B1E1",fontSize:"12px",width: "85px",color: "white" },
        iconName: "MdFilterAlt",
        iconSize: 12,
        children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
        onClick: () => {
          setShowFilters((prev) => !prev);
          setShowColumns(false);
          console.log("clicked")
        },
      },
     
 

    {
      className: "btnthird border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExport(true),
    },
    {
      className: "btn-info border-0 d-flex",
      style: { gap: "2px", height: "28px", fontSize: "12px" },
      iconName: "MdOutlineUpdate",
      iconSize: 12,
      children: "Last Updated On",
      onClick: () => console.log("Last updated clicked"),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/quality-action-list/new-quality-action",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add Quality Action",
    },
  ];


  const handleFilterChange = (newFilters) => {
    setCurrentPage(1);
    setFilters(newFilters);
  };

  useMemo(() => {
    setSelectAll(false);
    setSelectedRows([]);
  }, [currentPage]);

  return (
    <div className="container-fluid d-flex flex-column m-auto" style={{ flexGrow: 1, position: 'relative' }}>
      <Tabs />

      <ListLayout
        breadcrumbItems={[
          { label: "Quality Action List", style: { color: "#4b002b",
            fontSize: "20px" } },
        ]}
        actionButtons={actionButtons}
      >
        {showFilters && (
          <div style={{top: '100%', right: '20px', zIndex: 1050 }}>
            <ListFilters
              filtersConfig={filtersConfig}
              onFilterChange={handleFilterChange}
              currentFilters={filters}
              setShowFilters={setShowFilters}
            />
          </div>
        )}

        {showColumns && (
          <ConfigureColumnsNew
            show={showColumns}
            onClose={() => setShowColumns(false)}
            onSave={handleSaveColumns}
            docType="Quality Action"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map((col) => ({
              fieldname: col.accessor,
              label: col.name,
            }))}
            disabledFields={["siNo", "action", "select", "settings"]}
          />
        )}

      

        <Table
          columns={visibleColumns}
          data={tableData}
          loading={false}
          className="no-vertical-lines"
          style={{
            '--table-border-width': '0.5px',
            '--table-cell-padding': '16px 20px',
            '--table-header-bg': '#f9fafb',
            '--table-border-color': '#e5e7eb',
            '--table-hover-bg': '#f8fafc'
          }}
        />
   

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={10}
          totalRecords={filteredRows.length}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />

        {showExport && (
          <ExportCSV
            doctype="Quality Action"
            fieldsData={exportFields}
            onClose={() => setShowExport(false)}
          />
        )}
      </ListLayout>
    </div>
  );
};

export default MainList;
